import React from "react";

const ReportsSummary = () => (
  <div id="reports_summary" className="section">
    <h2>4.1 Summary</h2>
    <p>This page contains various dashboard sections that grant overviews of:</p>
    <ul>
      <li>Progress</li>
      <li>Completions</li>
      <li>Activity</li>
      <li>Score Distribution</li>
      <li>Licence Allocation</li>
    </ul>
    <p>
      Note that which dashboard items are displayed, and the reports that are available, will depend
      on the course selection.
    </p>
    <img
      src="../images/help/allcourses_summary_report.png"
      alt="User Progress"
      className="center"
    />
  </div>
);

export default ReportsSummary;
